// Copies live under /dashboard/tsdb so ProtectedRoutes keeps the full-screen dashboard layout.
export const TSDB_ROUTE_PREFIX = '/dashboard/tsdb';
const ES_ROUTE_PREFIX = '/dashboard';

export const TSDB_PAGES = [
  'smartCity-dashboard',
  'traffic-dashboard',
  'event-dashboard',
  'cctv-dashboard',
  'cctvDetail-dashboard',
  'psc-dashboard',
  'ambulance-dashboard',
] as const;
export type TsdbPage = (typeof TSDB_PAGES)[number];

export const isTsdbPath = (pathname: string): boolean =>
  pathname.startsWith(`${TSDB_ROUTE_PREFIX}/`);

export const copiedPage = (pathname: string): TsdbPage | undefined =>
  TSDB_PAGES.find((page) => pathname === `${ES_ROUTE_PREFIX}/${page}`);

/** Same-origin link to a copied page -> its /dashboard/tsdb copy; anything else unchanged. */
export const toTsdbHref = (href: string): string => {
  const url = new URL(href, window.location.origin);
  const page = url.origin === window.location.origin ? copiedPage(url.pathname) : undefined;
  return page ? `${TSDB_ROUTE_PREFIX}/${page}${url.search}${url.hash}` : href;
};

export const toEsPath = (pathname: string): string =>
  isTsdbPath(pathname) ? `${ES_ROUTE_PREFIX}${pathname.slice(TSDB_ROUTE_PREFIX.length)}` : pathname;
